import { Directive } from '@angular/core';

@Directive({
  selector: '[ngxSbAudio]',
})
export class SbAudioDirective {

  constructor() { }

}
